import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';
import { LoginHelper } from '../../helpers/login.helper';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  isDisplay: boolean = false;
  email: string = '';
  responseMessage: string = '';
  isSubmitting = false;

  formForgotPassword = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(
    private loginHelper: LoginHelper,
    private authService: AuthService,
    private spinnerService: NgxSpinnerService,
    private toastService: ToastService,
    private router: Router) { }

  ngOnInit(): void {
    this.isDisplay = false;
  }

  get form(): any {
    return this.formForgotPassword.controls;
  }

  esqueceuSenha() {
    if (this.formForgotPassword.invalid) {
      return;
    }

    this.isSubmitting = true;
    this.spinnerService.show();
    
    const emailControl = this.formForgotPassword.get('email');
    if (emailControl) {
      const email = emailControl.value as string;
      this.authService.esqueceuSenha({ email })
        .subscribe({
          next: (res) => {
            this.loginHelper.signOut();
            this.isDisplay = true;
            this.responseMessage = res;
            this.retornarMensagemSucesso(res.message);
            this.spinnerService.hide();
            this.isSubmitting = false;
          },
          error: (e) => {
            this.retornarMensagemErro(e);
            this.isDisplay = true;
            this.spinnerService.hide();
            this.isSubmitting = false;
          }
        });
    } else {
      this.spinnerService.hide();
      this.isSubmitting = false;
    }
  }

  navigateToLogin() {
    this.router.navigate(['/login']);
  }

  retornarMensagemSucesso(mensagem: string) {
    this.toastService.setMensagemToast(mensagem, SeveridadeToast.Success);
  }

  retornarMensagemErro(e: any) {
    this.toastService.setMensagemToast('Erro ao redefinir senha: ' + e.error + '!', SeveridadeToast.Error);
  }
}
